import { render, staticRenderFns } from "./CallTable.vue?vue&type=template&id=5aee13dc&"
import script from "./CallTable.vue?vue&type=script&lang=ts&"
export * from "./CallTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports